import { z } from 'zod'
import { isValidPhone, validateCpf } from '@/helpers'

export const partnerFormSchema = z.object({
  name: z
    .string()
    .min(1, 'Obrigatório')
    .refine(
      (value) => /^[A-Za-zÀ-ÿ\s]+$/.test(value),
      'O nome deve conter apenas letras',
    )
    .refine(
      (value) => /\S+\s+\S+/.test(value),
      'Informe o nome completo (nome e sobrenome)',
    ),
  rg: z.string().min(1, 'Obrigatório'),
  tax_id: z
    .string()
    .min(1, 'Obrigatório')
    .refine(
      (value) => (value ? validateCpf(value) : true),
      'Insira um CPF válido',
    ),
  phone: z
    .string()
    .min(1, 'Obrigatório')
    .refine((value) => isValidPhone(value), 'Telefone inválido'),
  email: z.string().min(1, 'Obrigatório').email('E-mail inválido'),
  profession: z.string().min(1, 'Obrigatório'),
  nationality: z.string().min(1, 'Obrigatório'),
  marital_status: z
    .enum(['single', 'married', 'stable_union', 'divorced', 'widow'])
    .or(z.string().refine((val) => val !== '', 'Obrigatório')),
  joint_property_regime: z.string().optional(),
  county_of_birth: z.string().min(1, 'Obrigatório'),
  address: z.object({
    zip_code: z.string().min(1, 'Obrigatório'),
    street: z.string().min(1, 'Obrigatório'),
    number: z.string().min(1, 'Obrigatório'),
    district: z.string().min(1, 'Obrigatório'),
    ibge_code: z.string().min(1, 'Obrigatório'),
    state_code: z.string().min(1, 'Obrigatório'),
    complement: z.string().max(30, 'Máximo de 30 caracteres').optional(),
  }),
  has_cnh: z.union([
    z.boolean(),
    z.string().refine((val) => val !== '', 'Obrigatório'),
  ]),
  government_employee: z.union([
    z.boolean(),
    z.string().refine((val) => val !== '', 'Obrigatório'),
  ]),
  contributor_inss: z.union([
    z.boolean(),
    z.string().refine((val) => val !== '', 'Obrigatório'),
  ]),
  is_other_company_partner: z.union([
    z.boolean(),
    z.string().refine((val) => val !== '', 'Obrigatório'),
  ]),
  is_main_partner: z.boolean().optional(),
  race: z.union([
    z.enum(['white', 'black', 'mixed', 'yellow', 'indigenous']),
    z.string().refine((val) => val !== '', 'Obrigatório'),
  ]),
  specializations: z.array(z.string()).optional(),
  crm: z.string().optional(),
  voter_registration: z.string().optional(),
  income_tax: z.string().optional(),
  pis: z.string().optional(),
})

export type PartnerFormData = z.infer<typeof partnerFormSchema>
